import { render, staticRenderFns } from "./OptionNameLabel.vue?vue&type=template&id=241b1302&scoped=true"
import script from "./OptionNameLabel.vue?vue&type=script&lang=js"
export * from "./OptionNameLabel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "241b1302",
  null
  
)

export default component.exports